import { HTMLAttributes } from "react"
import { CSSFn, callCSSFn, styled, StyleProps } from "../styles"
import { flexCss } from "../Flex"

interface OwnProps {
  css?: CSSFn
}
type Props = HTMLAttributes<HTMLDivElement> & OwnProps

export const getCardCss = (props: StyleProps & OwnProps) => ({
  ...flexCss,
  backgroundColor: props.theme.palette.white,
  padding: props.theme.spacing(6),
  ...callCSSFn(props),
})

export const Card = styled.div<Props>((props: StyleProps) => getCardCss(props))
